import React, { Component } from 'react';
import axios from 'axios';
import '../styles/styles.css';
import Account from '../components/account';
import Todo from '../components/todo';
import NewProject from '../components/newProject';
import Projects from '../components/projects';
import Brand from '../components/brand';

import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import withStyles from '@material-ui/core/styles/withStyles';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import NotesIcon from '@material-ui/icons/Notes';
import Avatar from '@material-ui/core/avatar';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import CircularProgress from '@material-ui/core/CircularProgress';
import { authMiddleWare, refreshAuthToken } from '../util/auth';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';

const drawerWidth = 240;

const styles = (theme) => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  avatar: {
    height: 110,
    width: 100,
    flexShrink: 0,
    flexGrow: 0,
    marginTop: 20
  },
  uiProgess: {
    position: 'fixed',
    zIndex: '1000',
    height: '31px',
    width: '31px',
    left: '50%',
    top: '35%'
  },
  toolbar: theme.mixins.toolbar
});

class home extends Component {
  state = {
    render: 'projects',
    firstName: '',
    lastName: '',
    profilePicture: '',
    uiLoading: true,
    imageLoading: false,
    projectToShow: null
  };


setViewWithHistory = (newRender, project = null) => {
  const stateForHistory = {
    render: newRender,
    projectToShow: project
  };

  // React-State setzen
  this.setState(stateForHistory);

  // Ein Eintrag in den Browser-Verlauf
  window.history.pushState(stateForHistory, '');
};

  // Navigation innerhalb von "home" über State
  loadAccountPage  = async () => {
      try {
    await refreshAuthToken();   // Token auffrischen
      } catch (e) {
        console.error('Token-Refresh fehlgeschlagen', e);
      }
  this.setViewWithHistory("account", null);
  };


  loadTodoPage = () => {
  this.setViewWithHistory("home", null);
  };

loadProjectsPage = async () => {
      try {
          await refreshAuthToken();   // Token auffrischen
      } catch (e) {
        console.error('Token-Refresh fehlgeschlagen', e);
      }
  this.setViewWithHistory('projects', null);
  };

loadBrandPage = async () => {
  try {
    await refreshAuthToken();
  } catch (e) {
    console.error('Token-Refresh fehlgeschlagen', e);
  }
  this.setViewWithHistory('brand', null);
};


  loadNewProjectPage = async (event, viewMode) => {
  console.log("WAS WURDE AN LOADYS NEW PAGE FUNC ÜBERGEBEN", viewMode);

      try {
            await refreshAuthToken();
          } catch (e) {
            console.error('Token-Refresh fehlgeschlagen', e);
            // optional: hier könntest du z.B. auf /login redirecten
            // this.props.history.push('/login');
          }
      
  // Standard: neues Projekt
  if (!viewMode || viewMode === 'newProject') {
    this.setViewWithHistory('newProject', null);
    return;
  }

  if (viewMode === 'editProject') {
    if (event.project && event.project.projectId) {
      this.setViewWithHistory('editProject', event.project);
    }
    return;
  }

  if (viewMode === 'viewProject') {
    if (event.project && event.project.projectId) {
      this.setViewWithHistory('viewProject', event.project);
    }
    return;
  }

  if (viewMode === 'deleteProject') {
    if (event.project && event.project.projectId) {
      this.setViewWithHistory('deleteProject', event.project);
    }
    return;
  }
};

  logoutHandler = () => {
    localStorage.removeItem('AuthToken');
    this.props.history.push('/login');
  };

  constructor(props) {
    super(props);
    this.loadNewProjectPage = this.loadNewProjectPage.bind(this);
  }

  componentDidMount = () => {
    authMiddleWare(this.props.history);
    const authToken = localStorage.getItem('AuthToken');

    axios.defaults.headers.common = { Authorization: `${authToken}` };
    axios
      .get('/user')
      .then((response) => {
        this.setState({
          firstName: response.data.userCredentials.firstName,
          lastName: response.data.userCredentials.lastName,
          email: response.data.userCredentials.email,
          phoneNumber: response.data.userCredentials.phoneNumber,
          country: response.data.userCredentials.country,
          username: response.data.userCredentials.username,
          uiLoading: false,
          profilePicture: response.data.userCredentials.imageUrl
        });
        
        
         window.history.replaceState(
        {
          render: this.state.render,
          projectToShow: this.state.projectToShow
        },
        ''
      );

      // 👉 Auf Browser-Zurück / Vorwärts reagieren
      window.onpopstate = (event) => {
        if (event.state && event.state.render) {
          this.setState({
            render: event.state.render,
            projectToShow: event.state.projectToShow || null
          });
        } else {
          // Fallback: wenn kein State vorhanden ist
          this.setState({ render: 'projects', projectToShow: null });
        }
      };
        
        
      })
      .catch((error) => {
        if (error.response.status === 403) {
          this.props.history.push('/login');
        }

        if (error.response.status === 500) {
          window.location.reload();
        }
        console.log(error);
        this.setState({ errorMsg: 'Error in retrieving the data' });
      });
      
      
      
      
  };

  render() {
    const { classes } = this.props;

    if (this.state.uiLoading === true) {
      return (
        <div className={classes.root}>
          {this.state.uiLoading && <CircularProgress size={150} className={classes.uiProgess} />}
        </div>
      );
    } else {
      // Welche Komponente soll angezeigt werden?
      let renderedComponent = <Todo />;

      switch (this.state.render) {
        case 'home':
          renderedComponent = <Todo handler={this.loadNewProjectPage} />;
          break;

        case 'account':
          renderedComponent = <Account history={this.props.history} />;
          break;

        case 'newProject':
          renderedComponent = (
            <NewProject
              handler={this.loadNewProjectPage}
              viewMode="newProject"
              history={this.props.history}
            />
          );
          break;

        case 'editProject':
          renderedComponent = (
            <NewProject
              handler={this.loadNewProjectPage}
              viewMode="editProject"
              project={this.state.projectToShow}
              history={this.props.history}
            />
          );
          break;

        case 'viewProject':
          renderedComponent = (
            <NewProject
              handler={this.loadNewProjectPage}
              viewMode="viewProject"
              project={this.state.projectToShow}
              history={this.props.history}
            />
          );
          break;

        case 'deleteProject':
          renderedComponent = (
            <NewProject
              handler={this.loadNewProjectPage}
              viewMode="deleteProject"
              project={this.state.projectToShow}
              history={this.props.history}
            />
          );
          break;

        case 'projects':
          renderedComponent = (
            <Projects handler={this.loadNewProjectPage} history={this.props.history} />
          );
          break;
              
        case 'brand':
          renderedComponent = <Brand history={this.props.history} />;
          break;      

        default:
          renderedComponent = (
            <Projects handler={this.loadNewProjectPage} history={this.props.history} />
          );
          break;
      }

      return (
        <div className={classes.root}>
          <CssBaseline />
          <AppBar position="fixed" className="appBar">
            <Toolbar>
              <h6 className="appBarHeadline" noWrap="true">
                <FontAwesomeIcon icon={faEye} /> moval office
              </h6>
            </Toolbar>
          </AppBar>
          <Drawer
            className={classes.drawer}
            variant="permanent"
            classes={{
              paper: classes.drawerPaper
            }}
          >
            <div className={classes.toolbar} />
            <Divider />
            <center>
              <Avatar src={this.state.profilePicture} className={classes.avatar} />
              <p>
                {this.state.firstName} {this.state.lastName}
              </p>
            </center>
            <Divider />
            <List>
              <ListItem button key="Projects" onClick={this.loadProjectsPage}>
                <ListItemIcon>
                  <NotesIcon />
                </ListItemIcon>
                <ListItemText primary="Projects" />
              </ListItem>

              <ListItem button key="Account" onClick={this.loadAccountPage}>
                <ListItemIcon>
                  <AccountBoxIcon />
                </ListItemIcon>
                <ListItemText primary="Account" />
              </ListItem>

              <ListItem button key="New Project" onClick={this.loadNewProjectPage}>
                <ListItemIcon>
                  <AccountBoxIcon />
                </ListItemIcon>
                <ListItemText primary="New Project" />
              </ListItem>
          
          <ListItem button key="Brand" onClick={this.loadBrandPage}>
          <ListItemIcon>
            <AccountBoxIcon />
          </ListItemIcon>
          <ListItemText primary="Brand" />
        </ListItem>

              <ListItem button key="Logout" onClick={this.logoutHandler}>
                <ListItemIcon>
                  <ExitToAppIcon />
                </ListItemIcon>
                <ListItemText primary="Logout" />
              </ListItem>
            </List>
          </Drawer>

          {/* Hier wird die ausgewählte Komponente angezeigt */}
          {renderedComponent}
        </div>
      );
    }
  }
}

export default withStyles(styles)(home);
